import { Hotel } from "typings/microserviceModels/hotels-flex-module";
import TruncatedText from "shiitake";
import * as React from "react";

export const Description = ({ hotel }: { hotel: Hotel }) => {
  const { shortDescription } = hotel;

  if (!shortDescription || shortDescription.length === 0) {
    return null;
  }

  return (
    <TruncatedText
      lines={3}
      renderFullOnServer={true}
      overflowNode={"\u2026"}
      className="truncatedReview uitk-type-paragraph-300 all-x-padding-three all-y-margin-zero all-b-padding-three"
      tagName="p"
    >
      {`${shortDescription}`}
    </TruncatedText>
  );
};
